<template>
	<div
		v-if="user.subscription && user.subscription.is_started"
	>
		<h3
			v-html="`Ordine in corso`"
		/>

		<div
			v-if="noOrder"
		>
			<section>
				<div
					class="button-group"
				>
					<div
						class="label"
						v-html='`Non hai ancora effettuato una selezione per questa settimana, ricorda di farlo entro ${ $_dates_dateCutOff }. Clicca su "Fai la tua spesa" per sceglierle.`'
					/>

					<router-link :to="{ name: 'flow-new' }">
						<CTA
							:content="`Fai la tua spesa`"
						/>
					</router-link>
				</div>
			</section>

		</div>

		<div class="table" v-else-if="order">
			<div class="table-row">
				<div
					class="table-cell"
					v-html="`Numero ordine:`"
				/>	
				<div
					class="table-cell"
					v-html="order.id"
				/>
			</div>

			<tracking-code
				class="table-row"
				:order="order"
			/>

			<div class="table-row" v-if="order.prices.plan > 0" >
				<div
					class="table-cell"
					v-html="`Piano:`"
				/>
				<div
					class="table-cell"
					v-html="`${order.plan.meals} ricette per ${ order.plan.people } persone`"
				/>
			</div>

			<div
				class="table-row"
        v-if="order.prices.plan > 0"
			>
				<div
					class="table-cell"		
					v-html="`Prezzo piano:`"
				/>
				<div class="table-cell">
					€ {{ order.prices.plan }}
					<div class="inline" v-if="order.is_paid">
						<i class="fa fa-check" aria-hidden="true"></i> Pagato
					</div>
				</div>
			</div>

			<div
				class="table-row"
				v-if="order.prices.recipes > 0"
			>
				<div
					class="table-cell"		
					v-html="`Premium:`"
				/>
				<div class="table-cell">
					€ {{ order.prices.recipes }}
				</div>
			</div>


			<div
				class="table-row"
				v-if="order.prices.extras > 0"
			>
				<div
					class="table-cell"		
					v-html="order.prices.plan > 0 ? `Prezzo altri prodotti:` : `Prezzo spesa`"
				/>
				<div class="table-cell">
					€ {{ order.prices.extras }}
				</div>
			</div>

			<div
				class="table-row"
				v-if="orderHasEdenred"
			>
				<div
					class="table-cell"		
					v-html="`Buoni pasto:`"
				/>
				<div class="table-cell">
					€ {{ order.transactions.edenred }}
				</div>
			</div>

			<div
				class="table-row"
			>
				<div
					class="table-cell"		
					v-html="`Prezzo consegna:`"
				/>
				<div class="table-cell">
					{{ deliveryPriceCalculated | deliveryPrice }}
				</div>
			</div>

			<div
				class="table-row"
				v-if="orderHasDiscount"
			>
				<div
					class="table-cell"		
					v-html="`Sconto:`"
				/>
				<div class="table-cell">
					-€ {{ order.prices.discount  }}
				</div>
			</div>

			<template v-if="order && !order.is_skip">
				<div class="table-row">
					<div
						class="table-cell"
						v-html="`Consegna:`"
					/>
					
					<div
						class="table-cell"
						v-html='`prevista per ${ $_dates_readableDate(order.date.delivery) }`'
					/>
				</div>

				<div
					class="table-row"
				>
					<div
						class="table-cell"
						v-html="`Tipo di consegna:`"
					/>
					<div
						class="table-cell first-lower"
						v-if="delivery"
						v-html="isFP ? 'Consegna punto di ritiro' : 'Consegna a domicilio'"
					/>

					<div
						class="table-cell first-lower"
						v-else
					>
						<div class="placeholder" />
					</div>
				</div>

				<div
					class="table-row"
				>
					<div
						class="table-cell"
						v-html="`Tipo di spedizione:`"
					/>
					<div
						class="table-cell first-lower"
						v-html="`corriere tradizionale ${timeRanges}`"
					/>
				</div>

				<div
					class="table-row"
				>
					<div
						class="table-cell"
						v-html="`Indirizzo:`"
					/>

					<div
						class="table-cell"
						v-if="(address && delivery)"
					>
	            		<span>{{ delivery.name }}, </span>
	            		<span v-if="address.name">{{ address.name }}, </span>
                        <span>{{ address.street }}, {{ address.zip_code }}, {{ address.city }}</span>
					</div>

					<div
						class="table-cell"
						v-else
					>
						<div class="placeholder" />
					</div>
				</div>
			</template>
		</div>

		<div
			class="items-listing"
			v-if="order && order.recipes"
		>
			<SliderQ
				:maxNumSlides="6"
				:minSizeOfSlide="150"
				:minNumSlides="2"
				v-if="order.recipes.concat(order.extras).length > 0"
			>
				<slide v-for="(item, index) in order.recipes.concat(order.extras)">
					<small-item-box
						:itemTitle="item.title + ' Qt '+ item.quantity"
						:itemImage="item.images ? item.images.small ? item.images.small : item.images.big : ''"
						:itemUrl="item.url ? `/ricetta/${item.url}` : null"
					/>
				</slide>
			</SliderQ>
		</div>

		<div v-if="order && !order.closed && order.is_skip">
			<br>
			<p
				v-html="`Questo ordine è stato saltato.`"
			/>
		</div>

		<div v-if="order && order.closed">
			<br>
			<p
				v-html="order.is_skip ? `Questo ordine è stato saltato.` : `Non è più possibile modificare o cancellare l'ordine.`"
			/>
		</div>

		<br>

		<div v-if="order && order.is_to_process && !order.is_skip">
			<div class="button-group">
				<div class="label">
					Addebiteremo € {{ order.prices.net }} sul tuo conto {{ dateCheckout }}.  Potrai sempre modificare il tuo ordine fino a {{ $_dates_dateCutOff }}.
				</div>
				<div style="display:flex">
					<router-link
						:to="{name: 'flow-subscribed'}"
					>
						<CTA
							:content="`Modifica l'ordine`"
						/>
					</router-link>
	             	
	             	<order-delete class="mx-5" v-if="!orderClosed" />
	             </div>

			</div>

			<!--<div class="button-group">
				<div
					class="label"
					v-html="`Completa la tua spesa settimanale con birre, vini, stuzzicherie e molto altro ancora`"
				/>

				<router-link
					:to="{ name: 'ecommerce' }"
				>
					<CTA		
						:content="orderHasExtra ? 'Modifica Colazioni, Pranzi e Sfizi' : 'Aggiungi Colazioni, Pranzi e Sfizi'"
						:color="`orange`"
						isStar
					/>
				</router-link>
			</div>-->
		</div>
	</div>
</template>

<script>
import SmallItemBox from '../Parts/SmallItemBox'
import TrackingCode from './TrackingCode'

import { dates } from '../../mixins/dates'
import { prices } from '../../mixins/prices'
import { dashboard } from '../../mixins/dashboard'
import { subscription } from '../../mixins/subscriptionActions'

import { subscriptionStore } from '../../store/subscriptionStore'
import { deliveryStore } from '../../store/deliveryStore'
import { orderStore } from '../../store/orderStore'

import { Order } from '../../core/Order'
import OrderDelete from '../Elements/OrderDelete'

export default {
	mixins: [
		dates,
		subscription,
		dashboard,
		prices
	],

	components: {
		OrderDelete,
		TrackingCode,
		SmallItemBox
	},

	data () {
		return {
			subscriptionStore: subscriptionStore.state,
			deliveryStore: deliveryStore.state,
			orderStore: orderStore.state
		}
	},

	filters: {
		deliveryPrice (val) {
			if (val === '0.00') return 'GRATUITA'
			return `€ ${val.replace('.', ',')}`
		}
	},

	computed: {
		user () {
			return this.$root.user
		},

		order () {
			return this.orderStore.order
		},

		address () {
            return this.delivery
                && this.deliveryStore
                && this.deliveryStore.address.delivery.find(r => +r.id === this.delivery.address_id)
                && this.deliveryStore.address.delivery.find(r => +r.id === this.delivery.address_id).attributes
        },

        delivery () {
            var sub = this.user.subscription
            return this.deliveryStore
                && this.deliveryStore.deliveries.order.find(r => orderStore.state.order && r.attributes.target_id === orderStore.state.order.id)
                && this.deliveryStore.deliveries.order.find(r => orderStore.state.order && r.attributes.target_id === orderStore.state.order.id).attributes
        },

		isFP () {
			return this.delivery
				&& this.delivery.code
				&& this.delivery.code.includes('FP')
		},

		deliveryPriceCalculated () {
			return this.order.prices.delivery
		},

		dateCheckout () {
			return this.$_dates_readableDate(this.order.date.checkout)
		},

		timeRanges () {
			if (this.deliveryStore.timeRanges.delivery.length <= 0) return ''
			return `(${this.deliveryStore.timeRanges.delivery[0].attributes.start.slice(0, -3)} - ${this.deliveryStore.timeRanges.delivery[0].attributes.end.slice(0, -3)})`
		}
	},

	methods: {
		loadOrder () {
			if (!this.user.order) return 
			orderStore.state.order = new Order(this.user.order)
		},
		loadCalendar () {
			return subscriptionStore.getCalendar({ token: this.user.subscription.token })
		},
		loadDeliveryAndTimeRange () {
			
			var timeRanges = this.delivery && this.delivery.time_ranges && this.delivery.time_ranges[0]
				? this.deliveryStore.timeRanges.delivery.find(r => r.id === this.delivery.time_ranges[0].id)
				: null
			var address = this.deliveryStore.address.delivery.find(r => +r.id === +this.delivery.address_id)
			
			if (address && timeRanges) return

        	return deliveryStore.getDelivery({ 
	        	target_type: 'order', 
	        	target_id: this.user.subscription.id,
	        	include: 'timeRanges,address'
	    	})
        }
	},

	mounted () {
		this.loadOrder()
		this.loadCalendar()
		this.loadDeliveryAndTimeRange()
	}
}

</script>

<style scoped>
.items-listing {
	margin: 0 -10px;
}

.table {
	margin: 10px 0;
	text-align: left;
	width: auto;
}


.table-cell {
	padding: 10px 20px 10px 0;
}

.table-cell:first-child {
	color: #5a5959;
	font-weight: bold;
}

.first-lower:first-letter {
	text-transform: lowercase;
}

.placeholder {
	background: #ededed;
	height: 15px;
}


@media (max-width: 700px) {
	.table-cell {
		padding: 10px 10px 10px 0;
	}

	.button-group .label {
		margin-right: 10px;
	}

	.button-group .btn,
	.button-group a {
		width: 100%;
	}
}
</style>
